import React, { useRef, useState } from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    FORM,
    INTERNATIONAL,
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import ProgramLangs from "./_langs";
import {
    FL_ACTIVITY,
    FL_IMAGE,
    FL_ORDER,
    FL_STATUS,
} from "../../../components/i18n/formLabels";
import {
    PH_IMAGE,
} from "../../../components/i18n/placeHolders";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos} from "../../../redux/actions/generalActions/formActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {programService} from "../../../jwt/_services/clasificator/programService";
import {setForm, setItem} from "../../../redux/actions/generics/IndexedActions";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import SelectGeneric from "../../../components/select/selectGeneric";
import {activityProvider} from "../../../providers/activityProvider";

const ProgramForm = (props) => {
    const path = props.path || 'atv/program';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { app, udn, editMode, disableInputs, domainObject } = componentState?.data || {};
    const translatedLangs = domainObject?.translatedLangs

    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [activityId, setActivityId] = useState( editMode ? domainObject?.activity?.id : null);
    const [status, setStatus] = useState(domainObject?.status !== undefined ? domainObject.status : true);

    const [resetValues, setResetValues] = useState(false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
    });

    const handleSwitchs = (field) => {
        const tmpObject = JSON.parse(JSON.stringify(domainObject)) || {}
        tmpObject[field] = tmpObject[field] ? !tmpObject[field] : true
        props.setItem(tmpObject)
    }

    const {register, handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            fileName: domainObject?.fileName,
            status: domainObject?.status,
            showOrder: domainObject?.showOrder
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase: { id : app?.fbDataBase?.id },
            item : {
                ...data,
                udn: { id : udn?.id },
                activity: { id : activityId },
                id: domainObject?.id,
                status: status,
            }
        };

        if (langs && langs.length){
            dataRequest.item.langs = langs;
        }

        if (editMode) {
            let id = domainObject.id;
            genericIndexedActions.update(path, programService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, programService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }

    return (<>
    <Form onSubmit={handleSubmit(onSubmit)}>
        <Card className={'card-modal-medium'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'}> { (domainObject?.title || domainObject?.name || '') }</h2>
                        <br/>
                        <h5 className={'card-modal-uid'}> {'     uid: ' + (domainObject?.uid || '')}</h5>
                    </>
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_ORDER}</Label>
                            <Input type="number" name="showOrder"
                                   innerRef={register}
                                   disabled={disableInputs}/>
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_IMAGE}</Label>
                            <Input type="text" name="fileName"
                                   placeholder={PH_IMAGE}
                                   innerRef={register}
                                   disabled={disableInputs}/>
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_ACTIVITY }</Label>
                            <br/>
                            <SelectGeneric
                                isDisabled={disableInputs}
                                initialValue={activityId}
                                setExternalValue={setActivityId}
                                provider={activityProvider}
                                resetValue={resetValues}
                                customFilter={{
                                    onlyRegistered: true,
                                    fbDataBase: { id : app?.fbDataBase?.id },
                                    item: {
                                        udn: { id: udn?.id },
                                        status : true,
                                        isExtraordinary : false
                                    }
                                }
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    onChange={() => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <div className={'form-container'}>
                    <div className={''}>
                        <h2>{INTERNATIONAL}</h2>
                    </div>
                    <div className={''}>
                        <Row>
                            <Col>
                                <ProgramLangs
                                    langs={langs}
                                    setLangs={setlangs}
                                    translatableLangs={translatedLangs}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            </CardBody>
        </Card>
    </Form>
        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>)
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(ProgramForm)
